import { MARKETPLACE_FEATURE } from '@/config/marketplaceCapabilities.js';

export default [
  {
    title: 'Brand Analytics',
    channel: 'amazon-seller',
    icon: { icon: 'material-symbols:area-chart-outline-rounded' },
    // No group-level envOnly: Search Catalog · Competition and Search Query have
    // shipped, and VerticalNavGroup gates the group itself — a dev-only group would
    // hide its released children on prod. The remaining children stay individually
    // dev-only.
    feature: MARKETPLACE_FEATURE.BRAND_ANALYTICS,
    children: [
      {
        title: 'Market Basket',
        action: 'read',
        subject: 'User',
        to: 'brand-analytics-market-basket',
        icon: { icon: 'ic:outline-shopping-basket' },
        envOnly: 'development',
      },
      {
        title: 'Brand Metrics',
        action: 'read',
        subject: 'User',
        to: 'brand-analytics-brand-metrics',
        icon: { icon: 'ic:outline-monitor-heart' },
        envOnly: 'development',
      },
      {
        title: 'Repeat Purchase',
        action: 'read',
        subject: 'User',
        to: 'brand-analytics-repeat-purchase',
        icon: { icon: 'ic:outline-repeat' },
        envOnly: 'development',
      },
      {
        title: 'Search Catalog',
        action: 'read',
        subject: 'User',
        to: 'brand-analytics-search-catalog',
        icon: { icon: 'ic:outline-inventory-2' },
        envOnly: 'development',
      },
      {
        title: 'Search Catalog · Shipping',
        action: 'read',
        subject: 'User',
        to: 'brand-analytics-search-catalog-shipping',
        icon: { icon: 'ic:outline-local-shipping' },
        envOnly: 'development',
      },
      {
        title: 'Search Catalog · Competition',
        action: 'read',
        subject: 'User',
        to: 'brand-analytics-search-catalog-shipping-competition',
        icon: { icon: 'ic:outline-insights' },
      },
      {
        title: 'Search Query',
        action: 'read',
        subject: 'User',
        to: 'brand-analytics-search-query',
        icon: { icon: 'ic:outline-search' },
      },
      {
        title: 'Top Search Terms',
        action: 'read',
        subject: 'User',
        to: 'brand-analytics-search-terms',
        icon: { icon: 'ic:outline-trending-up' },
        envOnly: 'development',
      },
      {
        title: 'Search Term Results',
        action: 'read',
        subject: 'User',
        to: 'ppc-search-term-asins',
        icon: { icon: 'ic:outline-manage-search' },
        envOnly: 'development',
      },
    ],
  },
];
